export default "__VITE_ASSET__d60931e3__"